// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ovR1{padding-top:2.5rem}._3ovR1:first-child{margin-top:.75rem}._3ovR1+.SYoTq{margin-top:1.5rem}._1xY33{margin-top:.625rem;border:1px solid #595757;border-radius:4px;text-align:center;padding:1.625rem 0}._1cEOz{margin:.375rem 0 1.25rem;font-weight:600;font-size:16px;font-size:1rem;line-height:20px;line-height:1.25rem}._1cEOz,._2Va6U{font-weight:500;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._2Va6U{margin-bottom:1rem;font-size:24px;font-size:1.5rem;line-height:30px;line-height:1.875rem}@media(max-width:767px){._2Va6U{font-size:1.25rem;line-height:1.5625rem}}._2kl4G{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center}@media(min-width:1024px){._2kl4G>*{margin-right:1rem}}@media(max-width:1023px){._2kl4G{-ms-flex-direction:column;flex-direction:column}._2kl4G>*{margin-bottom:1rem}}", ""]);
// Exports
exports.locals = {
	"root": "_3ovR1",
	"section": "SYoTq",
	"question": "_1xY33",
	"questionHint": "_1cEOz",
	"title": "_2Va6U",
	"buttonGroup": "_2kl4G"
};
module.exports = exports;
